import RoundSlider from "./RoundSlider";

(function () {
  const styles = ".onOffStyle {\n  display: flex;\n  align-items: center;\n}\n.onOffStyle .slider {\n  width: 33px;\n  background-color: #5A5A5A;\n}\n.onOffStyle .slider:before {\n  height: 15px;\n  width: 15px;\n}\n.onOffStyle .switch {\n  width: 33px;\n  height: 19px;\n}\n.onOffStyle .switchSpan {\n  font-size: 14px;\n  font-family: inherit;\n  color: #3A86BF;\n}\n.onOffStyle .switchSpan:not(.checked) {\n  color: #5A5A5A;\n}\n\n.onOffStyle input:checked + .slider:before {\n  -webkit-transform: translateX(14px);\n  -ms-transform: translateX(14px);\n  transform: translateX(14px);\n}";
  const fileName = "index_RoundSlider";
  const element = document.querySelector("style[data-sass-component='index_RoundSlider']");

  if (!element) {
    const styleBlock = document.createElement("style");
    styleBlock.innerHTML = styles;
    styleBlock.setAttribute("data-sass-component", fileName);
    document.head.appendChild(styleBlock);
  } else {
    element.innerHTML = styles;
  }
})();

export default RoundSlider;